export const roles = [
    "CEO",
    "IT_ADMIN",
    "OPERATIONS",
    "ACCOUNTANT",
    "LOGISTICS",
    "STOREKEEPER",
    "VIEWER",
];
export const roleLabels = {
    CEO: "Генеральный директор",
    IT_ADMIN: "IT-администратор",
    OPERATIONS: "Операционный менеджер",
    ACCOUNTANT: "Бухгалтер",
    LOGISTICS: "Логистика",
    STOREKEEPER: "Кладовщик",
    VIEWER: "Только просмотр",
};
